import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
//components
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const SurfaceMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(() => import('./SurfaceRouteMain'), 'surface') as any,
    ),
);
export default SurfaceMainLazy;
